import { cx } from 'emotion';
import React, { useContext } from 'react';

import { CssTransition } from '@ezugi/primitives';
import { DeviceInfo } from '@ezugi/utils';

import {
  spinnerContainerClassName,
  playButtonClassName,
  activePlayButton,
  tapToPlayLabelClassName,
  tapContainerClassName,
  SPINNER_SIZE,
} from '../style.css';
import LogoSpinner from './LogoSpinner';
import { PreloaderContext } from './PreloaderContext';

export type PreloaderSpinnerProps = {
  className?: string;
  isLoading: boolean;
  isTapToPlayVisible: boolean;
  playLabel: string;
}

export const PreloaderSpinner: React.FC<Pick<PreloaderSpinnerProps, 'className'>> = ({
  className,
}) => {
  const {
    isLoading,
    isTapToPlayVisible,
    playLabel,
    spinner: CustomSpinner,
  } = useContext(PreloaderContext);

  if (CustomSpinner) {
    return (
      <CustomSpinner
        isLoading={isLoading}
        isTapToPlayVisible={isTapToPlayVisible}
        playLabel={playLabel}
        className={className}
      />
    );
  }

  const showTapToPlay = DeviceInfo.isHandheld && !isLoading && isTapToPlayVisible;

  return (
    <div className={cx(spinnerContainerClassName, className)}>
      <CssTransition effect="fade" visible={isLoading}>
        <LogoSpinner size={SPINNER_SIZE} />
      </CssTransition>
      <div className={tapContainerClassName}>
        <div
          className={cx(playButtonClassName, {
            [activePlayButton]: showTapToPlay,
          })}
        />
        <div
          className={tapToPlayLabelClassName}
          style={{ visibility: showTapToPlay ? 'visible' : 'hidden' }}
        >
          {playLabel}
        </div>
      </div>
    </div>
  );
};
